module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Fire.ce8a8cfb.png";